import { Formik, Form } from 'formik';
import CurrentCompanyUserColleaguesQuery from 'graphql/user/currentCompanyUserColleagues';
import React from 'react';
import * as Yup from 'yup';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
} from '@mui/material';

import { Job } from '@libs/graphql-types';
import {
  ConnectedGraphSelect,
  OptionType,
} from '@libs/ui/components/form/select';
import { ConnectedTextEditor } from '@libs/ui/components/form/text-editor/ConnectedTextEditor';

interface JobEditPopupProps {
  open: boolean;
  onClose: () => void;
  jobData: Job;
  onSubmit: (values: {
    description: string;
    campaign_owner_id: string;
  }) => void;
}

const mapColleaguesToOptions = (user: any): OptionType => {
  return {
    text: [user.first_name, user.last_name].filter(Boolean).join(' '),
    value: user.id,
  };
};

const validationSchema = Yup.object({
  description: Yup.string().required('Description is required'),
  campaign_owner_id: Yup.string().required('Job owner is required'),
});

export const JobEditPopup: React.FC<JobEditPopupProps> = ({
  open,
  onClose,
  jobData,
  onSubmit,
}) => {
  const initialValues = {
    description: jobData.description || '',
    campaign_owner_id: jobData.campaign_owner?.id || '',
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Job Details</DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          await onSubmit(values);
          actions.setSubmitting(false);
          onClose();
        }}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={3} direction="column">
                <Grid item>
                  <ConnectedGraphSelect
                    name="campaign_owner_id"
                    query={CurrentCompanyUserColleaguesQuery as any}
                    dataPath="currentCompanyUserColleagues"
                    dataMap={mapColleaguesToOptions}
                    fullWidth
                    variant="filled"
                    disabled={isSubmitting}
                    label="Campaign owner (hiring manager)"
                    formControlProps={{ size: 'small' }}
                  />
                </Grid>
                <Grid item>
                  <Box border="1px solid #eee">
                    <ConnectedTextEditor
                      disabled={isSubmitting}
                      name="description"
                      placeholder="Description"
                    />
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: '0 24px 24px' }}>
              <Button
                onClick={onClose}
                color="info"
                variant="outlined"
                fullWidth
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                fullWidth
                color="info"
                variant="contained"
                disabled={isSubmitting}
              >
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default JobEditPopup;
